export default {
  computed: {
    // 服务人员或订单-评价新增
    isAdd() {
      return (
        (!!this.workerUid || !!this.orderCode) && this.$route.query.ht === 'add'
      )
    },
    // 评价修改
    isModify() {
      return (
        (!!this.orderCode || !!this.commentId) &&
        this.$route.query.ht === 'modify'
      )
    },
    isMaA() {
      return this.isAdd || this.isModify
    },
    // 普通的评价查看
    isLook() {
      return !!this.commentId && this.$route.query.ht === 'look'
    },
    // 订单的评价查看
    isOrderLook() {
      return !!this.orderCode && this.$route.query.ht === 'look'
    },
    // 服务人员id 服务人员只有新增评价
    workerUid() {
      return this.$route.query.workerUid
    },
    // 订单号 订单进入
    orderCode() {
      return this.$route.query.orderCode
    },
    // 评价id 评价列表进入带评价id
    commentId() {
      return this.$route.query.commentId
    },
    // 工号
    workerCode() {
      return this.$route.query.workerCode
    },
    // 品类名称
    categoryName() {
      return this.$route.query.categoryName
    }
  }
}
